import { defineMessages } from 'react-intl';

export const messages: {
	close: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	close: {
		id: 'company-hub-common.config-panel.panel-close-button.close-label',
		defaultMessage: 'Close configuration panel',
		description: 'Accessibility text for the cross button to close the config panel',
	},
});
